import { ActionTypes } from '../constants/action_types'

export const dashboardViewAction = (value) => {
    return {
        type: ActionTypes.DASHBOARD_VIEW,
        payload: value
    }
}